<!-- MOSTRA EL COMPONENT DELS DOCUMENTS DIGITALS DE LES ROUTEPARTS D'UNA RUTA -->
<shared-external-ecmrs-digitaldocument></shared-external-ecmrs-digitaldocument>
<div class="signaturahardman">
    <img class="logoimg" src="/assets/images/HardmanLogoBlanc.png" alt="Hardman logo">
    <a href="https:hardman.app" target="_blank" class="powered">{{'GLOBAL.DESENVOLUPATPER' | translate }}</a>
</div>